import React from 'react';
import PropTypes from 'prop-types';
import { colors } from '@nerdwallet/base-styles/variables';
import Image from '@nerdwallet/react-image';
import {
  APPLY_NOW_LINK_TYPES,
  LINK_TYPES,
  MarketplaceApplyNowImpression,
} from '@nerdwallet/react-marketplace-apply-now';
import {
  getImageSrc,
  getDisplayName as getName,
} from '@nerdwallet/marketplace/selectors/common';

import {
  boolCheckboxSpec,
  stringInputSpec,
} from '../../../lib/editing-configs';

import './apply-now.less';

const ApplyNow = ({
  ctaCopy,
  impressionId,
  logoLink,
  marketplaceEntity,
  rowIndex,
  hideIcon,
}) => (
  <div className="upt-apply-now">
    <MarketplaceApplyNowImpression
      // if we have an image wrapped in an apply link, don't include the annotation
      disableBankCtaAnnotation={logoLink}
      displayPage="DIGITAL_MARKETING"
      id={impressionId}
      linkType={APPLY_NOW_LINK_TYPES.institutionImage}
      marketplaceEntity={marketplaceEntity}
      productLocation={logoLink ? 'logo' : 'cta'}
      productPosition={rowIndex}
      showIcon={!hideIcon}
      text={ctaCopy}
      type={logoLink ? LINK_TYPES.LINK : LINK_TYPES.BUTTON}
    >
      {logoLink ? (
        <Image
          src={getImageSrc(marketplaceEntity)}
          alt={`${getName(marketplaceEntity)}'s logo`}
          className="upt-apply-now__image"
          backgroundColor={colors.transparent}
          objectFit="contain"
        />
      ) : null}
    </MarketplaceApplyNowImpression>
  </div>
);

ApplyNow.propTypes = {
  ctaCopy: PropTypes.string,
  marketplaceEntity: PropTypes.object,
  impressionId: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  logoLink: PropTypes.bool,
  rowIndex: PropTypes.number,
  hideIcon: PropTypes.bool,
};

ApplyNow.defaultProps = {
  ctaCopy: null,
  logoLink: false,
  hideIcon: false,
};

ApplyNow.getEditingConfig = () => [
  stringInputSpec('ctaCopy', 'CTA Copy'),
  boolCheckboxSpec('hideIcon', 'Hide lock icon?'),
];

export default ApplyNow;
